<div class="flex justify-center w-full">
  <div class="flex flex-col w-full" >
    @if (selectPaymentMethod()) {
      <div class="mb-6">
        <p class="text-gray-600">Seleccioná o agregá un medio de pago para continuar.</p>
      </div>
    }

    <!-- Payment Methods Selection -->
    @if (selectPaymentMethod()) {
      <div class="space-y-6">
        <div>
          <app-payment-method-list
            [paymentMethods]="paymentMethodsWithSelection()"
            [loading]="paymentsLoading()"
            [title]="'Tus medios de pago'"
            (paymentMethodSelected)="setExistingPayment($event)"
          />
        </div>
        
        <div class="mt-6 space-y-3">
          @if (availablePaymentTypes().length > 1) {
            <activar-button
              color="primary"
              fill="clear"
              expand="block"
              text="+ Agregar medio de pago"
              (click)="showPaymentTypeSelection()"
            />
          } @else {
            <activar-button
              color="primary"
              fill="clear"
              expand="block"
              [text]="hasMercadoPago() ? '+ Agregar tarjeta de crédito/débito' : '+ Agregar tarjeta de crédito'"
              (click)="showAddCreditCardMethod()"
            />
          }
        </div>
      </div>
    }

    <!-- Payment Type Selection -->
    @if (showPaymentTypeSelector()) {
      <div class="space-y-6">
        <div class="flex flex-col items-start justify-between">
           @if (userPaymentMethods().length > 0 || paymentMethods().length > 0) {
             <activar-back-button text="Volver a mis medios de pago" (click)="showPaymentMethods()"
              class="mb-5"
            />
          }
          <h3 class="text-lg font-medium text-gray-700">Seleccionar tipo de medio de pago</h3>
         
        </div>

        <div class="space-y-3">
          @for (paymentType of availablePaymentTypes(); track paymentType.type) {
            <button
              class="w-full p-4 border border-gray-200 rounded-lg text-left hover:bg-gray-50 transition-colors"
              (click)="handlePaymentTypeSelection(paymentType.type)"
            >
              <div class="flex items-center space-x-3">
                <div class="flex-shrink-0">
                  <activar-icon [name]="getPaymentTypeIcon(paymentType.type)" size="24px" />
                </div>
                <div>
                  <p class="text-sm font-medium text-gray-900">{{ paymentType.name }}</p>
                </div>
              </div>
            </button>
          }
        </div>
      </div>
    }

    <!-- Add New Payment Method -->
    @if (addPaymentMethod()) {
      <div class="space-y-6">
        <div class="flex items-center justify-between">
          <h3 class="text-lg font-medium text-gray-700">Agregar medio de pago</h3>
          @if (userPaymentMethods().length > 0 || paymentMethods().length > 0) {
            <activar-back-button
              text="Volver a mis medios de pago"
              (click)="showPaymentMethods()"
            />
          }
        </div>

        <app-add-payment
          [paymentGateways]="paymentGateways()"
          [needSecurityCode]="false"
          (EventPaymentSubmit)="handleNewPayment($event)"
        />
      </div>
    }

    <!-- Add Credit Card Method -->
    @if (addCreditCardMethod()) {
      <div class="space-y-6">
        <div class="flex flex-col items-start justify-between">
          @if (userPaymentMethods().length > 0 || paymentMethods().length > 0) {
            <activar-back-button
              text="Volver a mis medios de pago"
              (click)="showPaymentMethods()"
              class="mb-10"
            />
          } @else if (availablePaymentTypes().length > 1) {
            <activar-back-button
              text="Volver"
              (click)="showPaymentTypeSelection()"
              class="mb-10"
            />
          }
          <h3 class="text-lg font-medium text-gray-700 mb-5">{{ hasMercadoPago() ? 'Agregar tarjeta' : 'Agregar tarjeta de crédito' }}</h3>
          
        </div>

        <app-add-credit-card
          [needSecurityCode]="false"
          (addPayment)="handleCreditCardPayment($event)"
        />
      </div>
    }

    <!-- Add CBU Form Method -->
    @if (addCbuFormMethod()) {
      <div class="space-y-6">
        <div class="flex flex-col items-start justify-between">
          @if (userPaymentMethods().length > 0 || paymentMethods().length > 0) {
            <activar-back-button
              text="Volver a mis medios de pago"
              (click)="showPaymentMethods()"
              class="mb-10"
            />
          } @else if (availablePaymentTypes().length > 1) {
            <activar-back-button
              text="Volver"
              (click)="showPaymentTypeSelection()"
              class="mb-10"
            />
          }
          <h3 class="text-lg font-medium text-gray-700 mb-5">Agregar CBU</h3>
          
        </div>

        <app-add-cbu-form
          (addPayment)="handleCbuFormPayment($event)"
        />
      </div>
    }

    <!-- Security Code Step -->
    @if (showSecurityCode()) {
      <div class="space-y-6">
        <div class="flex flex-col items-start">
          <activar-back-button
            text="Volver a mis medios de pago"
            (click)="backFromSecurityCode()"
            class="mb-5"
          />
          <h3 class="text-lg font-medium text-gray-700">Ingresá el código de seguridad</h3>
          <p class="text-sm text-gray-500 mt-1">Requerido por el medio de cobro seleccionado.</p>
        </div>
        <app-add-security-code (EventSecurityCode)="handleSecurityCode($event)" />
      </div>
    }

    <!-- Loading State -->
    @if (showLoadingState()) {
      <div class="flex justify-center items-center py-8">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500"></div>
      </div>
    }
  </div>
</div>